<template>
  <div class="static-content">
    <component
      :is="compMap[item.type]"
      v-for="(item, index) in config"
      :key="index"
      ref="resList"
      :data="item.data"
      :productionId="productionId"
      @track-btn-click="$emit('track-btn-click', arguments[0])"
    ></component>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import StaticImage from '@/modules/common/StaticImage.vue';
import StaticCode from './StaticCode.vue';
import StaticSwiper from './StaticSwiper.vue';
import StaticGif from '@/modules/common/StaticGif.vue';
export interface IConfig {
  type: string;
  title: string;
  data: any;
}
@Component({})
export default class StaticContent extends Vue {
  @Prop({ type: Array, default: () => [] }) config!: IConfig[];
  @Prop({ type: Number, default: 0 }) productionId!: number;
  compMap = {
    image: StaticImage,
    'flash-code': StaticCode,
    gif: StaticGif,
    swiper: StaticSwiper,
  };
  mounted() {
    const eleList: { el: HTMLElement; title: string }[] = [];
    for (let i = 0; i < this.$refs.resList.length; i++) {
      const { $el } = this.$refs.resList[i];
      eleList.push({ el: $el, title: this.config[i].title });
    }
    this.$emit('ele-list', eleList);
  }
}
</script>


